import { FormDialog } from 'components/dialog/form';
import { ConfirmDialog } from 'components/dialog/confirm'

import {
  AddTargetListResult,
  TargetListResult,
  usePostAddTargetList
} from 'interface/search/targetList'
import {
  TargetListFileForm,
  useTargetListFileForm
} from '../form/targetListFileForm'

type AddTargetDialogProps = {
  searchId: number
  targetList: TargetListResult
  onSubmit: (result: AddTargetListResult) => void
  onClose: () => void
}
export const AddTargetDialog = ({
  searchId,
  targetList,
  onSubmit,
  onClose
}: AddTargetDialogProps) => {
  const fileForm = useTargetListFileForm()
  const { loading, isDisabled, submit, confirm, setConfirm } = fileForm

  const [postListState, startListPost] = usePostAddTargetList<TargetListResult>(searchId, { onPosted: onSubmit })
  return (
    <>
      <FormDialog
        open
        fullWidth
        maxWidth='sm'
        title="ターゲット追加"
        isLoading={loading || postListState.posting}
        percent={
          (postListState.posting && postListState.count > 0) ? (
            (postListState.current * 100) / postListState.count
          ) : undefined
        }
        error={postListState.error}
        body={<TargetListFileForm {...fileForm}/>}
        submitLabel="実 行"
        isValid={!isDisabled}
        onSubmit={(e) => {
          e.preventDefault()
          submit((postData) => {
            startListPost({
              params: targetList,
              targetListId: targetList.listId,
              form: {
                identifier: postData.identifier,
                category: postData.category,
                score: postData.score,          
                data: postData.data
              }
            }, postData.data.length, 1000);
          })
        }}
        onClose={onClose}
      />
      { confirm ? (
        <ConfirmDialog
          message={confirm.title}
          onOk={() => {
            setConfirm(null)
            confirm?.onOk()
          }}
          onCancel={() => setConfirm(null)}
        />
      ) : <></> }
    </>
  )
}
